module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_8003.891c84a2.png";